import authUtils from '../../services/auth/authUtils';
import LegacyResetForm from './components/LegacyResetForm';
import CognitoResetForm from './components/CognitoResetForm';

const ResetLayout = () =>
  authUtils.isLegacyAuth() ? <LegacyResetForm /> : <CognitoResetForm />;
export default ResetLayout;
